import { getInsightsLifeAreas } from '@griply/utils';
import { useLifescans, useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useInsightsLifeAreas = () => {
  const user = useUser();
  const lifeAreas = useLocalizedLifeAreas();
  const lifeScans = useLifescans();

  return useMemo(
    () =>
      getInsightsLifeAreas({
        lifeAreas,
        hasLifeScans: !!lifeScans.length,
        insightsSettings: user?.settings?.insights,
        lifeAreaSorting: user?.settings?.lifeAreaSorting ?? [],
      }),
    [
      lifeAreas,
      lifeScans.length,
      user?.settings?.insights,
      user?.settings?.lifeAreaSorting,
    ],
  );
};
